import { ManeuverType as ManeuverTypeEnum } from "../../services/RuteplanAPI";
import TurnLeftIcon from '@mui/icons-material/TurnLeft';
import TurnRightIcon from '@mui/icons-material/TurnRight';
import TurnSlightLeftIcon from '@mui/icons-material/TurnSlightLeft';
import TurnSlightRightIcon from '@mui/icons-material/TurnSlightRight';
import StraightIcon from '@mui/icons-material/Straight';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import RoundaboutLeftIcon from '@mui/icons-material/RoundaboutLeft';

export interface IManeuverTypeProps {
    maneuverType: ManeuverTypeEnum;
}

export function ManeuverType(props: IManeuverTypeProps): JSX.Element {
    const {maneuverType} = props;

    return GetIconFromManeuverType(maneuverType);
}

function GetIconFromManeuverType(maneuverType: ManeuverTypeEnum) {
    
    switch (maneuverType) {
        case ManeuverTypeEnum.ESRI_DMT_TURN_LEFT:
            return <TurnLeftIcon />
        case ManeuverTypeEnum.ESRI_DMT_TURN_RIGHT:
            return <TurnRightIcon />
        case ManeuverTypeEnum.ESRI_DMT_BEAR_LEFT:
            return <TurnSlightLeftIcon />
        case ManeuverTypeEnum.ESRI_DMT_BEAR_RIGHT:
            return <TurnSlightRightIcon />
        case ManeuverTypeEnum.ESRI_DMT_SHARP_LEFT:
            return <TurnLeftIcon />
        case ManeuverTypeEnum.ESRI_DMT_SHARP_RIGHT:
            return <TurnRightIcon />
        case ManeuverTypeEnum.ESRI_DMT_STRAIGHT:
            return <StraightIcon />
        case ManeuverTypeEnum.ESRI_DMT_UTURN:
            return <UTurnLeftIcon />
        case ManeuverTypeEnum.ESRI_DMT_ROUNDABOUT:
            return <RoundaboutLeftIcon />
        case ManeuverTypeEnum.ESRI_DMT_UNKNOWN:
            return <CircleOutlinedIcon />
        case ManeuverTypeEnum.ESRI_DMT_DEPART:
            return <CircleOutlinedIcon />
        case ManeuverTypeEnum.ESRI_DMT_STOP:
            return <LocationOnIcon />
        default:
            return <CircleOutlinedIcon />
    }
}